import { retrieveCurrencyList } from '@/api/common'
import storage from '@/utils/storage'
import { bankersRound } from '@/utils/utils'
import { defineStore } from 'pinia'

export const useCurrencyStore = defineStore('bestdealer-currency', () => {
  /**
   * 兼容旧数据代码
   */
  const current = ref(storage.get('currencyData') ?? {
    fromCurrency: 'CNY',
    fromUnit: '¥',
    targetCurrency: 'USD',
    targetUnit: '$',
    rate: 0.139271
  })

  const list = ref([])

  const init = async () => {
    const { code, data } = await retrieveCurrencyList()

    if (code === 200) {
      const target = data.find(item => item.targetCurrency === current.value.targetCurrency) ?? data[0]
      current.value = target
      list.value = data
    }
  }

  const update = (currency) => {
    current.value = currency
  }

  /**
   * 货币金额转换函数
   * @param {number} amount - 要转换的金额
   * @param {string} from - 来源货币代码（如 "CNY"）
   * @param {string} to - 目标货币代码（如 "USD"）
   * @returns {string} 转换后的金额, 保留两位小数
   */
  function exchangeCurrency (amount, from, to) {
    if (from === to || list.value.length === 0) return amount

    const rate = exchangeRate(from, to)

    return bankersRound(amount * rate, 2)
  }

  /**
   * 汇率计算函数，1 from = {return} to
   * @param {*} from 来源货币代码（如
   * @param {*} to 目标货币代码
   * @returns {number} 计算后的汇率
   */
  function exchangeRate (from, to) {
    if (list.value.length === 0) return null
    if (from === to) return 1

    const supportCurrencies = ['CNY', ...list.value.map(item => item.targetCurrency)]
    if (!supportCurrencies.includes(from) || !supportCurrencies.includes(to)) throw new Error(`不支持的货币类型: from: ${from} to: ${to}`)

    const directRate = list.value.find(item => item.fromCurrency === from && item.targetCurrency === to)?.rate

    if (directRate) return directRate

    const reverseRate = list.value.find(item => item.fromCurrency === to && item.targetCurrency === from)?.rate

    if (reverseRate) return 1 / reverseRate
    return exchangeRate(from, 'CNY') * exchangeRate('CNY', to)
  }

  return { current, list, init, update, exchangeCurrency, exchangeRate }
}, {
  persist: true
})
